/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Više informacija",
  "CookieMessage.old.text":
    "Koristimo kolačiće kako bi naša web trgovina dobro funkcionirala. Pogledajte našu politiku kolačića.",
  "CookieMessage.link": "Prihvaćanje kolačića",
  "CookieMessage.more_information":
    "Pročitajte više o kolačićima na Krampovoj stranici",
  "CookieMessage.return": "Vrati se natrag",
  "CookieMessage.intro.body":
    "Ove kolačiće postavio je Kramp, ali i treće strane. Nepotrebno je reći da dobro brinemo o vašoj privatnosti. Ako u nastavku kliknete na „Prihvati kolačiće“, pristajete na korištenje ovih kolačića. Prihvaćanjem ovih kolačića osiguravate da naše web mjesto ispravno funkcionira. Primjeri za što se oni koriste su:",
  "CookieMessage.intro.list.1": "Automatska prijava u „Moj račun“",
  "CookieMessage.intro.list.2":
    "Analiza ponašanja posjetitelja za potrebe poboljšavanja web stranice",
  "CookieMessage.intro.list.3":
    "Izrada korisničkih profila koja nam omogućuje da vam pružimo personalizirane informacije i oglase",
  "CookieMessage.intro.extra":
    'Ako ne želite prihvatiti sve kolačiće, to možete promijeniti u svojim <a>postavkama</a>. Za više informacija pročitajte našu <a href="{legalLink}">privacy and cookie statement</a>',
  "CookieMessage.intro.title": "Kramp koristi kolačiće",
  "CookieMessage.settings.body":
    "Možete birati između tri postavke kolačića. Odabir standardne postavke omogućit će nam da vam pružimo najbolje iskustvo na web stranici.",
  "CookieMessage.settings.standard.title": "Standardno (najpopularnije):",
  "CookieMessage.settings.standard.body":
    "Kolačići koji se koriste za prijavu, naručivanje, analizu, personalizirane informacije, društvene mreže i kolačiće trećih strana.",
  "CookieMessage.settings.restricted.title": "Ograničeno:",
  "CookieMessage.settings.restricted.body":
    "Kolačići koji se koriste za prijavu u okviru analize narudžbi i za personalizirane informacije.",
  "CookieMessage.settings.highly_restricted.title": "Strogo ograničeno:",
  "CookieMessage.settings.highly_restricted.body":
    "Dopuštate isključivo minimalan broj kolačića. Koristi se isključivo za prijavu, naručivanje i omogućavanje funkcioniranja web stranice u razumnoj mjeri.",
  "CookieMessage.settings.options.title": "Evo što radimo:",
  "CookieMessage.settings.option.1":
    "Koristimo kolačiće kako bismo osigurali ispravno funkcioniranje ove web stranice",
  "CookieMessage.settings.option.2": "Istražujemo ponašanje korisnika",
  "CookieMessage.settings.option.3": "Pratimo osobne statistike",
  "CookieMessage.settings.option.4":
    "Prikazujemo informacije koje bi vam mogle biti zanimljive",
  "CookieMessage.settings.option.5": "Koristimo informacije za naše oglase",
  "CookieMessage.settings.option.6": "Pratimo anonimne statistike",
  "CookieMessage.settings.option.7": "Podijelite svoje osobne podatke",
  "CookieMessage.settings.title": "Postavke kolačića",
};
